import cookie from 'js-cookie';
import {APP_CODE, APP_COOKIE_NAME, MEMBER_COOKIE_NAME, SERVICE_ID} from '@iamteacherpc/consts/cookie';
import {getQuery} from '@common/utils/urlUtils.js';

export function isIamSchoolStudent() {
    if (cookie.get(APP_COOKIE_NAME.APP_CODE) === APP_CODE.STUDENT) {
        return true;
    }

    //NOTE APP_CODE가 반영되기 전 하위 호환성을 위하여. APP_CODE 반영 후 좀 지나면 없애도 됨
    if (cookie.get(MEMBER_COOKIE_NAME.SERVICE_ID) === SERVICE_ID.IAMSTUDENT) {
        return true;
    }

    if (getQuery().rst === SERVICE_ID.IAMSTUDENT) {
        return true;
    }

    return false;
};

